import * as React from "react"
import { Box, Typography } from "@mui/material"

import { LabelCountry } from "@components"
import { boxListRetailers } from "./styles"


export default function ListRetailers({ retailers }) {
    return <Box sx={ boxListRetailers }>
		{ retailers.map(({ data }, idx) => <Box key={idx} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography component="div" variant="body2">
                    <LabelCountry country={data.country} label={data.label} ellipsis={true} />
                </Typography>
            </Box>
        )}
	</Box>
}